import { fetcher } from '@commenda/utils';

import {
  ISaveServiceAuditFindingFeedbackParams,
  ISaveServiceAuditFindingFeedbackResponse,
  IServiceAuditorMutationResult,
} from './types';

export async function saveServiceAuditFindingFeedback({
  findingId,
  verdict,
  reason,
}: Readonly<ISaveServiceAuditFindingFeedbackParams>): Promise<
  IServiceAuditorMutationResult<ISaveServiceAuditFindingFeedbackResponse>
> {
  try {
    const response = await fetcher(
      `agent-platform/service-auditor/findings/${encodeURIComponent(findingId)}/feedback`,
      { method: 'PUT', body: { verdict, reason } }
    );
    const json = await response.json();
    if (!response.ok) {
      // Nest validation errors arrive as an array of messages.
      const message = Array.isArray(json?.message)
        ? json.message.join(' ')
        : json?.message;
      return {
        success: false,
        error: message || 'Failed to save the finding feedback',
      };
    }
    const data: ISaveServiceAuditFindingFeedbackResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to save the finding feedback',
    };
  }
}
